var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 200 200",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M154.229 100c0 3.369-1.239 6.744-3.714 9.373l-81.344 86.292c-5.147 5.459-13.729 5.691-19.17.518-5.432-5.178-5.662-13.798-.515-19.261l72.513-76.923-72.513-76.917c-5.147-5.469-4.917-14.093.515-19.266 5.441-5.173 14.023-4.941 19.17.522l81.344 86.292c2.475 2.625 3.714 6 3.714 9.37Z"
})));
export default SvgChevronRight;